import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filterByStatus',
    pure: false
})
export class FilterByStatusPipe implements PipeTransform {
    transform(items: any[], filterObjects: Object[]): any {
        if (!items || !filterObjects) {
            return items;
        }

        const selectedStatuses = filterObjects.filter((x: any) => x.selected).map((y: any) => y.value);
        if(selectedStatuses.length === 0) {
            return items;
        }
        
        return items.filter(item => selectedStatuses.includes(item.stateId));
    }
}